export default {
  title: 'Sourcing Channel Management',
  menu: 'Sourcing Channel Management',
  tab: {
    channelManagement: 'Channel Management',
    sourceCodeManagement: 'Source Code Management',
    channelAdd: 'Add Channel',
    sourceCodeEdit: 'Edit Source Code',
    sourceCodeAdd: 'Add Source Code'
  },
  label: {
    affiliatedCompany: 'Affiliated Company',
    chineseName: 'Chinese Name',
    englishName: 'English Name',
    status: 'Status',
    channelSelect: 'Select Channel',
    statusSelect: 'Select Status',
    all: 'All',
    enable: 'Enable',
    disable: 'Disable',
    channelAdd: 'Channel Add',
    channelEdit: 'Channel Edit',
    companyName: 'Company Name',
    classified: 'In Channel',
    unclassified: 'Not in Channel',
    source: 'Source',
    code: 'Code',
    channel: 'Channel',
    selectable: 'Selectable',
    sourceCodeEdit: 'Edit Source Code',
    sourceCodeAdd: 'Add Source Code',
    pleaseStartTyping: 'Please start typing',
    defaultChannel: 'Default Channel',
    parentChannel: 'Use Parent Company Channel',
    weChatChannel: 'WeChat'
  },
  placeholder: {
    search: 'Search',
    chineseName: 'Please enter chinese name',
    englishName: 'Please enter english name',
    source: 'Please enter source',
    code: 'Please enter code',
    channel: 'Please select channel'
  },
  message: {
    optionSuccess: 'Option Success',
    required: 'This field is required.'
  },
  tip: {
    selectableTip: 'Selectable during edit/upload candidate.'
  }
}
